const registerMainServiceWorkers = () => {
    if ('serviceWorker' in navigator) {
        //  If we register the service worker file at /example/sw.js, then the service worker would only see fetch events for pages whose URL starts with worker file at /example/sw.js, then the service worker would only see fetch events for pages whose URL starts with /example/ (i.e. /example/page1/, /example/page2/)
        const registeredFile = window.$pathBase + 'serviceWorkerAssets.min.js';

        window.addEventListener('load', function () {
            navigator.serviceWorker
                .register(registeredFile) // scope == window.$pathBase
                .then(
                    function (registration) {
                        console.log(
                            `ServiceWorker ${registeredFile} registration successful with scope: `,
                            registration.scope
                        );
                    },
                    function (err) {
                        // registration failed :(
                        console.error(
                            `ServiceWorker ${registeredFile} registration failed: `,
                            err
                        );
                    }
                );
        });
    }
};
export default { registerMainServiceWorkers };
